import Dexie, { type Table } from 'dexie'

export interface CachedAttachment {
  url: string
  filePath: string
  cachedAt: number
  stageId: string
  byteLength: number
}

class OfflineAttachmentDatabase extends Dexie {
  attachments!: Table<CachedAttachment>

  constructor() {
    super('offline-attachment-cache')

    this.version(1).stores({
      attachments: 'url, cachedAt',
    })

    this.version(2)
      .stores({
        attachments: 'url, cachedAt',
      })
      .upgrade(tx => tx.table('attachments').clear())

    // v3 adds stageId + byteLength so the offline-cache settings page can
    // group/size attachments per stage. Existing rows lack these fields, so
    // we clear the table on upgrade (mirrors v1→v2 strategy).
    this.version(3)
      .stores({
        attachments: 'url, stageId, cachedAt',
      })
      .upgrade(tx => tx.table('attachments').clear())

    // v4: an early v3 build wrote rows with empty `stageId` because
    // prefetchIssues didn't thread the active stageId into prefetchAttachments.
    // Clear the table so the next download writes correct values; orphaned
    // files are pruned by `restoreCachedAttachments` (sees empty index → rmdir).
    this.version(4)
      .stores({
        attachments: 'url, stageId, cachedAt',
      })
      .upgrade(tx => tx.table('attachments').clear())
  }
}

export const offlineAttachmentDb = new OfflineAttachmentDatabase()
